import React from 'react';

import MuiButton, { ButtonProps } from '@material-ui/core/Button';

const Button = (props: ButtonProps): JSX.Element => {
  const { children, ...buttonProps } = props;

  const labelClasses = buttonProps.classes ? buttonProps.classes.label || '' : '';
  const rootClasses = buttonProps.classes ? buttonProps.classes.root || '' : '';
  // const variantClasses = {
  //   label: `button__label--font-${style.fontSize}`,
  //   root: `button--${style.variant} button--${style.viewport} button--y-size-${style.ySize}${
  //     style.withShadow ? ' button--shadow' : ''
  //   }`
  // };

  return (
    <MuiButton
      {...buttonProps}
      classes={{
        ...buttonProps.classes,
        containedPrimary: 'button--primary',
        disabled: 'button--disabled',
        label: `button__label override ${labelClasses}`,
        outlined: 'button--outlined',
        root: `button override  ${rootClasses}`,
        sizeLarge: 'button--large',
        sizeSmall: 'button--small'
      }}
    >
      {children}
    </MuiButton>
  );
};

export { Button };
